/* eslint-disable */
import React, { FC, useEffect, useLayoutEffect } from 'react';
import { Button, Modal, Typography } from 'antd';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';

import features from '~/constants/features';
import WizardContent from '~/layouts/WizardContent';
import LeftLayout from '~/layouts/LeftLayout';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import { ClockReviewIcon, SubmitStageImg } from '~/img';
import WizardLayout from '~/layouts/uae/WizardLayout';
import {
  CheckCircleOutlined,
  CopyFilled,
  CopyOutlined,
} from '@ant-design/icons';
import { useGetApplication } from '~/controllers/wizard';
import { useDirection } from '~/hooks/i18nHooks';
import { usePageTitle } from '~/context/PageTitleContext';

const Merchant: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const { data }: any = useGetApplication();
  const dir = useDirection();
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle(t('Review'));
    return () => setPageTitle('');
  }, []);

  return (
    <StyledModal visible centered footer={null}>
      <Container dir={dir}>
        <div className="clock-icon-wrapper">
          <ClockReviewIcon />
        </div>
        <Typography.Title level={3} className="ReviewMerchant-Title">
          {t('Thank you for your application')}
        </Typography.Title>
        <Typography.Paragraph className="ReviewMerchant-Paragraph">
          {t("We'll review your submission and get back to you within 1–2 business days.")}
        </Typography.Paragraph>
        <div className="app-id-badge">
          <span className="app-id-label">{t('Application ID')}</span>
          <Typography.Paragraph
            className="app-id-value"
            copyable={{
              text: data?.applicationDisplayId,
              icon: [
                <CopyOutlined key="copy" />,
                <CheckCircleOutlined key="copied" />,
              ],
            }}
          >
            {data?.applicationDisplayId}
          </Typography.Paragraph>
        </div>

        <div className="support-section">
          <Typography.Paragraph className="support-text">
            {t('For support, call our customer services phone number below')}
          </Typography.Paragraph>
          <Typography.Paragraph className="support-number">920017697</Typography.Paragraph>
        </div>

        {/* <div className="copyLink">
          <Typography.Paragraph
            className="linkNafath"
            ellipsis
            copyable={{
              text: data?.uid,
              icon: [
                <>
                  <CopyOutlined />
                  <span>Copy</span>
                </>,
                <CheckCircleOutlined key="copied" />,
              ],
            }}
          >
            {data?.uid}
          </Typography.Paragraph>
        </div> */}
        {/* <Button
          onClick={() =>
            window.open(
              'https://portal.sandbox.ksa.ngenius-payments.com?tenant=NIARABIA',
              '_blank',
              'noopener,noreferrer'
            )
          }
          style={{ width: 280, fontWeight: 600 }}
          type="primary"
        >
          {t('Go to Test Portal')}
        </Button> */}
      </Container>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }
`;

const Container = styled.div`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  align-items: center;

  .ReviewMerchant-Title {
    color: var(--Neutral-Color-Text-colorText, #070707) !important;
    text-align: center;

    /* Heading 2/Medium */
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'var(--Font-Family, Inter)')}, sans-serif !important;
    font-size: var(--Font-Size-Main-Tokens-Heading-2, 30px) !important;
    font-style: normal;
    font-weight: 500 !important;
    line-height: var(--Font-Line-height-lineHeight-H2, 48px) !important;
    margin: 0 !important;
  }

  .ReviewMerchant-Paragraph {
    // margin-bottom: 20px;
  }

  .app-id-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    background: linear-gradient(135deg, #e8f4fd 0%, #f0f8ff 100%);
    border: 1.5px solid #b8d9f0;
    border-radius: 12px;
    padding: 16px 32px;
    min-width: 260px;
    box-shadow: 0 2px 8px rgba(0, 89, 150, 0.08);
  }

  .app-id-label {
    font-size: 11px;
    font-weight: 600;
    color: #005996;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .app-id-value {
    font-size: 13px;
    font-weight: 600;
    color: #003d6b;
    margin: 0 !important;
    letter-spacing: 0.5px;

    .ant-typography-copy {
      color: #005996;
      margin-left: 8px;
      font-size: 14px;
      opacity: 0.7;
      transition: opacity 0.2s;
      &:hover {
        opacity: 1;
      }
    }
  }

  .support-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
  }

  .support-text {
    color: #666;
    font-size: 14px;
    margin: 0;
    margin-bottom: 8px;
    text-align: center;
  }

  .support-number {
    color: #000;
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    text-align: center;
  }

  .clock-icon-wrapper {
    display: flex;
    padding: 24px;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 150px;
    background: var(--colorPrimary-colorPrimaryBgHover, #E6F0F7);

    svg {
      width: 36px;
      height: 36px;
    }
  }
  .linkNafath {
    overflow: hidden;
    //color: #005996;
    text-overflow: ellipsis;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.14px;
  }

  .copyLink {
    position: relative;
    background: #f5f9fc;
    border-radius: 8px;
    width: 260px;
    padding: 8px;
    height: 45px;
  }

  .nafathSubHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    gap: 16px;
  }

  .nafathParent {
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .nafathCode {
    width: 100px;
    height: 100px;
    border-radius: 100px;
    background-color: #e6f0f7;
    text-align: center;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 600;
  }
`;

export default Merchant;
